import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../Providers/AuthProvider';


const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = async (e) => {
    if (e) e.preventDefault();
    setError(null);

    if (!username.trim()) {
      setError('Escribe tu usuario');
      return;
    }

    if (!password.trim()) {
      setError('Escribe tu contraseña');
      return;
    }

    setIsLoading(true);
    
    const res = await login(username.trim(), password);
    setIsLoading(false);

    if (res.success) {
      if (res.user.role === 'BusinessAdmin' || res.user.role === 'SuperAdmin') {
        navigate('/admin/events-v2');
      } else {
        navigate('/admin/dashboard');
      }
    } else {
      setError(res.message || 'Usuario o contraseña incorrectos');
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handleLogin();
    }
  };

  return (
    <main className="container Login">
      <div className="row Login__Container">
        <div className="row">
          <img src="/img/page/xolos-five-bicolor.png" className="LogoADSLxZtudia" alt="Logo" />

          <h1 className="mt-2 text-center fs-4">Iniciar sesión</h1>

          <form className="mt-4" onSubmit={handleLogin} onKeyDown={handleKeyDown}>
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                id="txtUser"
                placeholder="Usuario"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                autoComplete="username"
                disabled={isLoading}
              />
            </div>

            <div className="mb-3">
              <input
                type="password"
                className="form-control"
                id="txtPassword"
                placeholder="Contraseña"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                disabled={isLoading}
              />
            </div>

            <button type="submit" className="Btn__Adsl--Red w-100" disabled={isLoading}>
              {isLoading ? 'Iniciando...' : 'Iniciar sesión'}
            </button>

            {error && (
              <p className="text-center text-danger mt-3">{error}</p>
            )}
          </form>
        </div>
      </div>
    </main>
  );
}

export { Login };